import React from 'react';

import Select from '../Select';
import ProductSearchFilter, { PAGE_SIZE } from './ProductSearchFilter';
import { Row } from '@commonsku/styles';

class PersonalProductSearchFilter extends ProductSearchFilter {

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.new_product) {
      this.setState({ total_products: 1, products: [nextProps.new_product] });
    }
  }

  loadDivisions() {
    this.props.loadDivisions('personal');
  }

  getEndpoint() {
    return 'product';
  }

  getSearchTerms(page) {
    let search_terms = {
      keyword_sku: this.state.search.search_term,
      owner_id: this.props.company_id,
      'max-results': PAGE_SIZE,
      'start-index': page * PAGE_SIZE
    };
    if (this.state.search.division_id) {
      search_terms.division_id = this.state.search.division_id;
    }
    if (this.state.search.net_min) {
      search_terms.net_min = this.state.search.net_min;
    }
    if (this.state.search.net_max) {
      search_terms.net_max = this.state.search.net_max;
    }
    return search_terms;
  }

  getInitialSearch(params) {
    if (params == 'reset') {
      return {
        search_term: '',
        division_id: '',
        net_min: '',
        net_max: ''
      };
    } else {
      return {
        search_term: this.props.user_search.search_term || '',
        division_id: this.props.user_search.personal_division_id || '',
        net_min: this.props.user_search.net_min || '',
        net_max: this.props.user_search.net_max || ''
      };
    }
  }

  render() {
    const { company_type, divisions, style } = this.props;
    const { search } = this.state;

    const division_id = search.division_id || (company_type === 'SUPPLIER' && divisions && divisions.length ? divisions[0].key : null);

    const onChangeDivision = division_id => this.onChangeDivision(division_id, 'personal_division_id');

    return (
      <>
        <Row style={{ paddingTop: '1rem' }}>

          <div className="medium-3 columns">
            <input
              type="text"
              placeholder="Search term"
              onChange={this.handleChangeSearchTerm}
              value={search.search_term}
              onKeyDown={this.handlePressEnter}
            />
          </div>
          <div className="medium-2 columns">
            {divisions &&
              <Select
                id="division"
                value={division_id}
                searchable={true}
                clearable={'SUPPLIER' !== company_type}
                options={divisions}
                change={onChangeDivision}
                placeholder="Supplier"
              />}
          </div>
          <div className="medium-4 columns">
            <div className="row">
              <div className="medium-5 columns">
                <input
                  type="text"
                  placeholder="Net min"
                  onChange={this.handleChangeNetMin}
                  value={search.net_min}
                  onKeyDown={this.handlePressEnter}
                />
              </div>
              <div className="medium-2 columns">
                <span>&mdash;</span>
              </div>
              <div className="medium-5 columns">
                <input
                  type="text"
                  placeholder="Net max"
                  onChange={this.handleChangeNetMax}
                  value={search.net_max}
                  onKeyDown={this.handlePressEnter}
                />
              </div>
            </div>
          </div>

          <div className="medium-3 columns">
            <div className="button-group expanded">
              <a className="button" onClick={this.handleClickSearch}>Search</a>
              <a className="button" onClick={this.handleClickReset}>Reset</a>
            </div>
          </div>
        </Row>
        <Row style={{ overflow: 'auto', ...style }} onScroll={this.handleScroll}>
          {this.renderProducts('personal')}
          {this.renderLoading()}
        </Row>
      </>
    );
  }
}

export default PersonalProductSearchFilter;
